import React, { useEffect, useState } from "react";
import soundFile from './audio/rg207a.wav'

//styling
import "./styles/index.css";

// data
import Results from "./data/results.json";
import Icons from "./data/icons.json";

// components
import Particle from "./components/Particle";
import Game from "./components/Game";

function App() {
  const [toggleInfo, setToggleInfo] = useState({
    visibility: false,
    value: "",
    slide: false,
  });
  const [toggleGame, setToggleGame] = useState(false);
  const audio = new Audio(soundFile)
  let result = "";

  const handleKeyboard = ({ repeat, key }) => {
    if (repeat) return;
    result = result + key
    if (result.substr(result.length - 4) === "236d") {
      audio.play()
      setToggleGame(true);
      result = "";
      document.removeEventListener("keydown", handleKeyboard)
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyboard);
  },[]);

  return (
    <div className="app">
      <Particle />
      <h1>BBCF Hall Of Fame</h1>
      {toggleGame ? (
        <Game />
      ) : (
        <div className="container">
          {Icons.map((index, key) => (
            <img
              className="container-item"
              key={key}
              src={index.icon}
              alt={index.name}
              onClick={() =>
                setToggleInfo({
                  visibility: true,
                  value: index.name,
                  slide: true,
                })
              }
            />
          ))}
        </div>
      )}
      {toggleInfo.visibility ? (
        <div className={"infoContainer " + (toggleInfo.slide ? "slide" : "")}>
          <div className="bioContainer">
            <img
              className="bioImage"
              src={Results[toggleInfo.value].image}
              alt={toggleInfo.value}
            />
            <h2>{toggleInfo.value}</h2>
            <p>🏆 {Results[toggleInfo.value].event.length}</p>
          </div>
          <div className="eventContainer">
            {Results[toggleInfo.value].event.map((index, key) => (
              <div key={key} className="events">
                <p>{index.type}</p>
                <p>{index.name}</p>
                <a href={`https://replaytheater.app/?game=bbcf&p1=${index.player}`}>
                  {index.player}
                </a>
                <a href={index.link}>link</a>
              </div>
            ))}
          </div>
          <h2
            className="close"
            onClick={() => setToggleInfo({ visibility: false, value: "" })}
          >
            X
          </h2>
        </div>
      ) : null}
    </div>
  );
}

export default App;
